// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/ResumableBox/styles.scss
// module id = 406
// module chunks = 0